import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ShimmerSocialPost, ShimmerTitle } from 'react-shimmer-effects';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import ShimmerImage, { ShimmerThumbnailImage } from '../../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../../default/utils/defaultAvatar';
import NoContentFound from '../../default/not-found/notFound';
import { PrismTimeFormatter } from '../../default/utils/timeFormatter';
import { DeleteCardAction } from '../model/cardActions';
import SingleLeadData from '../../lead/single/singLeadData';
import DataModelPopup from '../../default/popup/dataModel/contentModelPopup';
import SingleNotificationData from '../../notification/single/singleNotificationData';

const SingleCardData = ({ popupItemId = '', onClose }) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [openDataPopup, setDataPopup] = useState(false);
    const [dataPopupId, setDataPopupId] = useState('');
    const [notificationId, setNotificationId] = useState('');
    const [notificationStatus, setNtfStatus] = useState('');
    const [openNotificationPopup, setNotificationPopup] = useState(false);
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.lead-dropdown') &&
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
        }
    };
    const handleCloseModal = () => {
        setDataPopup(false);
    };
    useEffect(() => {
        // dropdown click outside detector
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    })

    const { id } = useParams();
    const [cardId, setCardId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [cardData, setLeadData] = useState(null);

    const store = useSelector((state) => state);
    const { data } = store.cardData;


    useEffect(() => {
        // Set cardId first
        const newCardId = popupItemId || id;
        setCardId(newCardId);
    }, [id, popupItemId]);

    // Separate useEffect for fetching data
    useEffect(() => {
        if (!cardId) return; // Don't fetch if cardId is not set

        const fetchCardData = async () => {
            if (data && data.length > 0) {
                const foundData = data.find(item => String(item.ID) === String(cardId));
                if (foundData) {
                    setLeadData(foundData);
                    setIsLoading(false);
                } else {
                    try {
                        const response = await axios.get(`/card/list?cardID=${cardId}`);
                        if (response.data && response.data.data && response.data.data.length > 0) {
                            setLeadData(response.data.data[0]);
                            setIsLoading(false);
                        } else {
                            setLeadData(null);
                            setIsLoading(false);
                        }
                    } catch (error) {
                        console.error('Error fetching card data:', error);
                        setLeadData(null);
                        setIsLoading(false);
                    }
                }
            } else {
                try {
                    const response = await axios.get(`/card/list?cardID=${cardId}`);
                    if (response.data && response.data.data && response.data.data.length > 0) {
                        setLeadData(response.data.data[0]);
                        setIsLoading(false);
                    } else {
                        setLeadData(null);
                        setIsLoading(false);
                    }
                } catch (error) {
                    console.error('Error fetching card data:', error);
                    setLeadData(null);
                    setIsLoading(false);
                }
            }
        };

        fetchCardData();
    }, [cardId, data]); // Depend on cardId and data

    // get lead data by card id
    const [getLeadById, setLeadById] = useState('');
    const [isLeadLoading, setLeadLoading] = useState(true);
    useEffect(() => {
        if (!cardId) return;
        const fetchLeadById = async () => {
            try {
                const response = await axios.get(`/prospector?limit=3&page=1&card=${cardId}`);
                if (response.data && response.data.data) {
                    setLeadById(response.data);
                    setLeadLoading(false)
                }
            } catch (error) {
                console.error('Error fetching lead data:', error);
                setLeadLoading(false)
            }
        };

        fetchLeadById();
    }, [cardId]);

    // get connection data by card id
    const [getConnectionById, setConnectionById] = useState('');
    const [isConnectionLoading, setConnectionLoading] = useState(true);
    useEffect(() => {
        if (!cardId) return;
        const fetchConnectionById = async () => {
            try {
                const response = await axios.get(`/card/connects/list?orderBy=name&page=1&limit=3&card=${cardId}`);
                if (response.data && response.data.data) {
                    setConnectionById(response.data);
                    setConnectionLoading(false)
                }
            } catch (error) {
                console.error('Error fetching connection data:', error);
                setConnectionLoading(false)
            }
        };

        fetchConnectionById();
    }, [cardId]);

    // get notification data by card id
    const [getNotificationById, setNotificationById] = useState('');
    const [isNotificationLoading, setNotificationLoading] = useState(true);
    useEffect(() => {
        if (!cardId) return;
        const fetchNotificationById = async () => {
            try {
                const response = await axios.get(`/notification/?page=1&limit=3&card=${cardId}`);
                if (response.data && response.data.data) {
                    setNotificationById(response.data);
                    setNotificationLoading(false)
                }
            } catch (error) {
                console.error('Error fetching notification data:', error);
                setNotificationLoading(false)
            }
        };

        fetchNotificationById();
    }, [cardId]);


    // Delete lead
    const MySwal = withReactContent(Swal)
    const handleDeleteLead = () => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await dispatch(DeleteCardAction(cardId));
                    if (response?.status === 200) {
                        if (onClose) {
                            onClose();
                        } else {
                            navigate('/lead');
                        }
                    }
                } catch (error) {
                    console.error('Error deleting lead:', error);
                }
            }
        });

    }
    // DataLeadPopup
    const handleDataLeadPopup = (dataId) => {
        setDataPopup(false);
        setDataPopupId(null);
        setTimeout(() => {
            setDataPopupId(dataId);
            setDataPopup(true);
        }, 100);
    }

    // data model popup
    const handleNotificationPopup = ( dataId, status) => {
        setNotificationPopup(false);
        setNotificationId(null);
        setNtfStatus(null);
        setTimeout(() => {
            setNotificationId(dataId);
            setNtfStatus(status);
            setNotificationPopup(true);
        }, 100);
    }
    // copy clipboard
    const [copyMessage, setCopyMessage] = useState('Copy');
    const [copyIcon, setCopyIcon] = useState('');
    const copyToClipboard = async (text, buttonId) => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(text);
                setCopyMessage("Copied");
                setCopyIcon('ri-check-double-line');
                return true;
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('Copy');
                document.body.removeChild(textArea);
                setCopyMessage("Copied");
                setCopyIcon('ri-check-double-line');
                return true;
            }
        } catch (err) {
            console.error('Failed to copy: ', err);
            return false;
        }
        finally {
            // Reset the message after 2 seconds
            setTimeout(() => {
                setCopyMessage("Copy");
                setCopyIcon('');
            }, 2000);
        }
    };

    return (
        <>
            {cardData && isLoading === false ? (
                <div className='sng-card-data-wrapper'>
                    <div className="connection-header lead-sng-header">
                        <h3></h3>
                        <div className="filter-wrapper">
                            <Link to={cardData.card_link} target='_blank' className="list-filter add-new-btn">
                                <i className="ri-external-link-line"></i>
                                <span>Preview</span>
                            </Link>
                            <Link to={`/card/settings/${cardId}`} className="list-filter add-new-btn">
                                <i className="ri-edit-box-line"></i>
                                <span>Edit</span>
                            </Link>
                            <div className="category-dropdown">
                                <div className="list-edit-dropdown lead-dropdown">
                                    <i
                                        className="ri-more-2-fill"
                                        onClick={() => toggleDropdown(999999)}
                                    ></i>
                                    {openDropdown === 999999 && (
                                        <ul>
                                            <li><Link onClick={() => handleDeleteLead()}>Delete</Link></li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sng-lead-item-view'>
                        <div className='card-profile-photo'>
                            {cardData.card_cover && (
                                <div className='card-cover-photo'>
                                    <ShimmerThumbnailImage
                                        src={cardData.card_cover}
                                        alt={cardData.card_name}
                                        width={500}
                                    />
                                </div>
                            )}
                            {cardData.card_photo ? (
                                <ShimmerImage
                                    src={cardData.card_photo}
                                    alt={cardData.card_name}
                                    width={130}
                                />
                            ) : (
                                <InitialAvatar
                                    title={`${cardData.card_name}`}
                                    size={130}
                                />
                            )}
                            <div className='card-profile-info'>
                                <h4><span>{cardData.card_name}</span></h4>
                                <p>{cardData.card_title} {cardData.card_company && cardData.card_title ? '•' : ''} {cardData.card_company}</p>
                            </div>
                        </div>
                        <div className="sng-card-statistic">
                            <div className='sng-card-leadData'>
                                {getLeadById && !isLeadLoading && (
                                    <>
                                        <div className='sng-sts-Header'>
                                            <h3>Leads</h3>
                                        </div>
                                        <div className='sng-sts-list'>
                                            <ul>
                                                {getLeadById.data && getLeadById.data.length > 0 && (
                                                    getLeadById.data.map((lead, index) => (
                                                        <li key={lead.id || index} onClick={() => {handleDataLeadPopup(lead.id)}}>
                                                            {lead.photo ? (
                                                                <ShimmerImage
                                                                    src={lead.photo}
                                                                    alt={lead.firstName}
                                                                    width={32}
                                                                />
                                                            ) : (
                                                                <InitialAvatar
                                                                    title={`${lead.firstName} ${lead.lastName}`}
                                                                    size={32}
                                                                />
                                                            )}
                                                            <div className='sng-sts-info'>
                                                                <h4>{`${lead.firstName} ${lead.lastName}`}</h4>
                                                                <span>{lead.title}</span>
                                                            </div>
                                                        </li>
                                                    ))
                                                )}

                                            </ul>
                                        </div>
                                        <div className='view-all-btn'>
                                            <Link to={`/lead?card=${cardId}`}>View all {getLeadById.pagination.data_total ? `(${getLeadById.pagination.data_total})` : ''}</Link>
                                        </div>
                                    </>
                                )}
                                {!isLeadLoading && !getLeadById && (
                                    <NoContentFound title="No lead found!" />
                                )}
                                {isLeadLoading &&
                                    <>
                                        <ShimmerTitle line={5} gap={10} variant="secondary" />
                                    </>
                                }
                            </div>

                            {/* connection data */}
                            <div className='sng-card-leadData'>
                                {getConnectionById && !isConnectionLoading && (
                                    <>
                                        <div className='sng-sts-Header'>
                                            <h3>Connections</h3>
                                        </div>
                                        <div className='sng-sts-list'>
                                            <ul>
                                                {getConnectionById.data && getConnectionById.data.length > 0 && (
                                                    getConnectionById.data.map((connection, index) => (
                                                        <li key={connection.id || index}>
                                                            {connection.card_photo ? (
                                                                <ShimmerImage
                                                                    src={connection.card_photo}
                                                                    alt={connection.card_name}
                                                                    width={32}
                                                                />
                                                            ) : (
                                                                <InitialAvatar
                                                                    title={`${connection.card_name}`}
                                                                    size={32}
                                                                />
                                                            )}
                                                            <div className='sng-sts-info'>
                                                                <h4>{`${connection.card_name}`}</h4>
                                                                <span>{connection.card_title}</span>
                                                            </div>
                                                        </li>
                                                    ))
                                                )}

                                            </ul>
                                        </div>
                                        <div className='view-all-btn'>
                                            <Link to={`/connection?card=${cardId}`}>View all {getConnectionById.pagination.data_total ? `(${getConnectionById.pagination.data_total})` : ''}</Link>
                                        </div>
                                    </>
                                )}
                                {!isConnectionLoading && !getConnectionById && (
                                    <NoContentFound title="No connection found!" />
                                )}
                                {isConnectionLoading &&
                                    <>
                                        <ShimmerTitle line={5} gap={10} variant="secondary" />
                                    </>
                                }
                            </div>

                            {/* Notification data */}
                            <div className='sng-card-leadData'>
                                {getNotificationById && !isNotificationLoading && (
                                    <>
                                        <div className='sng-sts-Header'>
                                            <h3>Notifications</h3>
                                        </div>
                                        <div className='sng-sts-list'>
                                            <ul>
                                                {getNotificationById.data && getNotificationById.data.length > 0 && (
                                                    getNotificationById.data.map((notification, index) => (
                                                        <li key={notification.id || index} onClick={() => {handleNotificationPopup(notification.id, notification.status)}}>
                                                            {notification.icon ? (
                                                                <ShimmerImage
                                                                    src={notification.icon}
                                                                    alt={notification.title}
                                                                    width={32}
                                                                />
                                                            ) : (
                                                                <InitialAvatar
                                                                    title={`${notification.title}`}
                                                                    size={32}
                                                                />
                                                            )}
                                                            <div className='sng-sts-info'>
                                                                <h4>{`${notification.title}`}</h4>
                                                                <span>{notification.content}</span>
                                                            </div>
                                                        </li>
                                                    ))
                                                )}

                                            </ul>
                                        </div>
                                        <div className='view-all-btn'>
                                            <Link to={`/notification?card=${cardId}`}>View all {getNotificationById.pagination.data_total ? `(${getNotificationById.pagination.data_total})` : ''}</Link>
                                        </div>
                                    </>
                                )}
                                {!isNotificationLoading && !getNotificationById && (
                                    <NoContentFound title="No notification found!" />
                                )}
                                {isNotificationLoading &&
                                    <>
                                        <ShimmerTitle line={5} gap={10} variant="secondary" />
                                    </>
                                }
                            </div>
                        </div>
                        {/* <div className='lead-header'>
                            
                        </div> */}
                        <div className='info-wrapper card-setting-overview'>
                            <div className='info-links'>
                                <h3>Overview</h3>
                                <div className="inline-flex-leadData">
                                    <h5>Card ID: #{cardData.settings.cardID}</h5>
                                    <span onClick={() => copyToClipboard(cardData.settings.cardID)} className="copy-text">
                                        <i className={copyIcon}></i> {copyMessage}
                                    </span>
                                </div>
                                <div className="inline-flex-leadData">
                                    <h5>Web view status</h5>
                                    <span className={cardData.settings.webViewStatus === "1" ? "enable" : "disable"}>
                                        {cardData.settings.webViewStatus === "1" ? "Enabled" : "Disabled"}
                                    </span>
                                </div>
                                <div className="inline-flex-leadData">
                                    <h5>SEO status</h5>
                                    <span className={cardData.settings.seoStatus === "1" ? "enable" : "disable"}>
                                        {cardData.settings.seoStatus === "1" ? "Enabled" : "Disabled"}
                                    </span>
                                </div>
                                <div className="inline-flex-leadData">
                                    <h5>Allow notification</h5>
                                    <span className={cardData.settings.notificationStatus === "1" ? "enable" : "disable"}>
                                        {cardData.settings.notificationStatus === "1" ? "Enabled" : "Disabled"}
                                    </span>
                                </div>
                                <div className="inline-flex-leadData">
                                    <div className='view-all-btn'>
                                        <Link to={`/card/settings/${cardId}`}>View/change settings</Link>
                                    </div>
                                </div>
                            </div>
                            <div className='info-history'>
                                <h3>History</h3>
                                {cardData.card_update !== null && (
                                    <p>Last edited<span className='date-format'>&nbsp;•&nbsp;
                                        {PrismTimeFormatter(cardData.card_update)}
                                    </span></p>
                                )}
                                <p>Card created date<span className='date-format'>&nbsp;•&nbsp;{PrismTimeFormatter(cardData.card_date)}</span></p>
                            </div>

                            {Array.isArray(cardData.cards) && cardData.cards.length > 0 && (
                                <div className='info-cards-history'>
                                    <h3>Visited Cards</h3>
                                    <ul>
                                        {cardData.cards && cardData.cards.map((item, index) => (
                                            <li>- <Link to={`https://cardiast.app/${item.cardID}`} key="index" target='_blank'>{item.cardName}<span className='date-format'>&nbsp;•&nbsp;{PrismTimeFormatter(item.date)}</span></Link></li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                    <DataModelPopup openModal={openDataPopup} setOpen={setDataPopup} children={true} sourceUrl={`/lead/single/${dataPopupId}`} bodyData={<SingleLeadData popupItemId={dataPopupId} onClose={handleCloseModal} />} />
                    <DataModelPopup openModal={openNotificationPopup} children={true} setOpen={setNotificationPopup} sourceUrl={`/notification/${notificationId}?status=${notificationStatus}`} bodyData={<SingleNotificationData popupItemId={notificationId} onClose={handleCloseModal} ntfStatus={notificationStatus} />} /> </div>
            ) : isLoading === false && (
                <NoContentFound title="Invalid Lead ID" />
            )}
            {isLoading &&
                <>
                    <ShimmerSocialPost type="text" title />
                </>
            }
        </>
    );
};

export default SingleCardData;